<script lang="ts" setup>
  import MessageIcon from '@/shared/components/icons/MessageIcon.vue'
  import { NEED_HELP_BUTTON_TEST_ID } from './NeedHelpButton.constants'

  interface Emits {
    (e: 'click'): void
  }
  const emit = defineEmits<Emits>()
</script>

<template>
  <button class="need-help-button" :data-testid="NEED_HELP_BUTTON_TEST_ID" @click="emit('click')">
    <MessageIcon class="need-help-button__icon" />
    <span class="need-help-button__title">{{ $t('qic_contact_us') }}</span>
  </button>
</template>

<style lang="scss" scoped>
  @import './NeedHelpButton';
</style>

<style lang="scss">
  @import '@/shared/assets/styles/mixins';
  @import '@/shared/assets/styles/colors';

  .need-help-button__icon {
    path {
      @include transition;

      stroke: transparentize($text-color-middle, 0.2);
    }
  }

  .need-help-button:hover {
    .need-help-button__icon {
      path {
        stroke: $text-color-middle;
      }
    }
  }
</style>
